module.exports = __webpack_public_path__ + "fonts/Didot-Bold.1da69c19.ttf";